export default class BaseEvent {
    constructor() {
        this.PRIORITY = 0;
        this.INDEX = 0;
        this.TIME = 0;
        this.BEAT = 0;
    }
}
